import { agentsRoute } from '@townsquare/routes/agents';
import { rovoEntitlementResource } from '@townsquare/rovo/entitlement';

import { AgentViewLoadable } from './components/AgentView';

agentsRoute.component = AgentViewLoadable;
agentsRoute.resources = [rovoEntitlementResource];
export const agentsRouterRoute = agentsRoute;
